import { Accordion, Alert, CardGroup } from '@ps/isp-web-component-library';
import { Translation } from '@ps/web-shared-components';
import classnames from 'clsx';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { getIsSgmOpportunity } from '@swf/core/models/sports/betSlip/utils/getIsOpportunity';
import { select } from '@swf/core/store';
import { Overlay } from '@swf/sports/components';

import ElementWithCount from '../../../ElementWithCount/ElementWithCount';
import Opportunity from '../Opportunity/Opportunity';

import {
  TXTWCL_Multiples,
  TXTWCL_Some_selections_canXt_be_combi_ELL
} from './MultipleOpportunities.messages.json';
import styles from './MultipleOpportunities.scss';
import ShowMore from './components/ShowMore/ShowMore';

const MultipleOpportunities: React.FC = () => {
  const multipleOpportunities = useSelector(select.betSlip.multipleOpportunities);
  const hasInvalidCombination = useSelector(select.betSlip.hasInvalidCombination);
  const [isExpanded, setExpanded] = useState<boolean>(false);

  if (!multipleOpportunities.length && !hasInvalidCombination) {
    return null;
  }

  const count = multipleOpportunities.length;
  const isAllOpportunitiesBetBuilder = !multipleOpportunities.some(
    (opportunity) => !getIsSgmOpportunity(opportunity)
  );
  const showMore = count > 1 && !isAllOpportunitiesBetBuilder;

  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <div className={styles.accordionWrapper}>
      <Accordion variant="quaternary">
        <Accordion.Header>
          <ElementWithCount
            count={count || undefined}
            element={<Translation {...TXTWCL_Multiples} />}
          />
        </Accordion.Header>
        <Accordion.Body>
          <>
            {hasInvalidCombination && (
              <div className={styles.invalidCombinationsMessage}>
                <Alert level="update" variant="passive-aggressive">
                  <Translation {...TXTWCL_Some_selections_canXt_be_combi_ELL} />
                </Alert>
              </div>
            )}

            {multipleOpportunities.length ? (
              <CardGroup isCondensed isPadded>
                {multipleOpportunities.map((opportunity, index) => {
                  const isHidden = !isExpanded && !getIsSgmOpportunity(opportunity) && !!index;

                  return (
                    <div
                      key={opportunity.id}
                      className={classnames(styles.opportunityWrapper, {
                        [styles.hidden]: isHidden
                      })}
                    >
                      <Overlay />
                      <Opportunity opportunity={opportunity} />
                    </div>
                  );
                })}

                {showMore && (
                  <div className={styles.showMoreWrapper}>
                    <Overlay />
                    <ShowMore isExpanded={isExpanded} onToggle={handleToggle} />
                  </div>
                )}
              </CardGroup>
            ) : null}
          </>
        </Accordion.Body>
      </Accordion>
    </div>
  );
};

export default MultipleOpportunities;
